import { gql } from "@apollo/client";

/**
 * GraphQL Query - Infrastructure layer
 * Fetches the global features lookup (count + items).
 */
export const GET_FEATURES = gql`
  query FeaturesLookup {
    featuresLookup {
      count
      items {
        featureId
        featureName
        featureKey
        featureDescription
        featureDisplayName
        featurePermissionsCount
        featureIsActive
        featureIsMainMenu
        featurePermissions {
          id
          name
          isActive
          createdAt
          createdBy
          deletedAt
          deletedBy
          updatedAt
          updatedBy
          description
          permissionKey
          allowedBotTypes
          allowedUserKinds
          allowedAdminTypes
        }
      }
    }
  }
`;
